import { createRequest } from "helpers/tools";

export const createDomainsAsync = async (domain) => {
    return await createRequest({
        suffix: `sources/allowed-domains`,
        method: "post",
        payload: domain,
        handleError: false,
    });
};
